export type FaqItem = {
  q: string;
  a: string;
};

export const FAQS: FaqItem[] = [
  {
    q: "吃瓜17每天什么时候更新？",
    a: "我们的内容团队会按“今日速递”的节奏滚动更新：白天重点跟进剧集、综艺与电影的首播和档期信息，晚间集中整理一天的热搜与热点话题复盘，方便你在不同时段都能看到新鲜内容。",
  },
  {
    q: "如何按栏目快速找到想看的内容？",
    a: "你可以在顶部导航进入“资讯速递”页，通过影视、综艺、音乐、明星动态与热点话题等分类标签进行筛选；首页也会按栏目分区展示最新内容，点进卡片即可阅读全文。",
  },
  {
    q: "文章里的热度值是怎么来的？",
    a: "热度值是我们综合阅读量、讨论量、转发与二创活跃度等多个维度加权后得出的参考指标，主要用于反映一条内容近期的讨论集中度，帮助读者快速判断什么话题最热。",
  },
  {
    q: "站内内容可以转载或引用吗？",
    a: "原创内容欢迎在注明来源“吃瓜17”的前提下非商业转载。涉及影视、综艺等素材的截图与片段，版权归原作者及平台所有，本站仅作资讯介绍与讨论之用。",
  },
  {
    q: "发现错误信息或希望投稿，应该联系谁？",
    a: "你可以通过“关于我们”页面的联系方式，将错误线索或投稿建议发送给我们。我们会在核实后及时更正信息，并对有价值的爆料线索给予致谢。",
  },
  {
    q: "吃瓜17与明星或艺人是否有官方合作？",
    a: "吃瓜17是一个面向普通用户的娱乐资讯聚合与讨论平台，与相关影视、综艺节目及艺人不存在官方授权或合作关系的绑定，站内内容以公开资讯整理为主。",
  },
];